<header>
  <app-header></app-header>
</header>

<main>
    <article>
        <div class="container" [ngClass]="{'txt-rtl': langService.isRightToLeft, 'txt-ltr':!langService.isRightToLeft}" (click)="antiTimeOut()">
            <div class="row">
                <div *ngIf="!isWide" class="col md-1 xs-0 "></div>
                <div  [ngClass]="{'col-md-12 col-xs-12': isWide, 'col-md-10 col-xs-12':!isWide}">
                    <router-outlet></router-outlet>
                </div>
                <div *ngIf="!isWide" class="col-md-1 col-xs-0 "></div>
            </div>
            <app-timeout-dialog></app-timeout-dialog>
        </div>
    </article>
</main>

<footer>
  <app-footer></app-footer>
</footer>
